import {BioentityAliasInfo} from 'constants/RegistryConstants';
import {graphQLToREST} from 'graphql-client/declarative-translations/external/translate';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {accessibleObjs} from 'graphql-client/InaccessibleInfo';
import {SidepanelItemListBioentitiesQuery} from 'nav/sidepanel/listing/__generated/SidepanelItemListBioentitiesQuery';

import {InaccessibleInfoGraphQL} from '../../../graphql-fragments/auth/__generated/InaccessibleInfoGraphQL';

type GraphQLBioentity = ExtractByTypename<
  SidepanelItemListBioentitiesQuery['bioentities'][number],
  'BasicFolderItemNode'
>;

const GQL_BAI_ID_SEPARATOR = '-';

export function bioentityIdFromBAIId(graphQLBAIId: string): string {
  return graphQLBAIId.split(GQL_BAI_ID_SEPARATOR)[0];
}

export function bioentityAliasInfosByBioentityId(
  bioentities: Array<GraphQLBioentity | InaccessibleInfoGraphQL>
): {
  [bioentityId: string]: Array<BioentityAliasInfo>;
} {
  // eslint-disable-next-line benchlint/no-spread-reduce
  return accessibleObjs(bioentities).reduce(
    (memo: {[bioentityId: string]: Array<BioentityAliasInfo>}, bioentity: GraphQLBioentity) => ({
      ...memo,
      [bioentity.id]: graphQLToREST('AliasesForBioentity', bioentity).bioentityAliasInfos,
    }),
    {}
  );
}
